{
    "BroadworksProvisioningHeader": "Broadworks Service Pack Provisioning",
    "BroadworksProvisioningTableHeaderEnabled": "Enabled",
    "BroadworksProvisioningTableHeaderItem": "Item",
    "BroadworksProvisioningTableHeaderServicePack": "Service Pack",
    "BroadworksProvisioningTableHeaderTelephonyServers": "Telephony Server(s)",
    "BroadworksProvisioningTableHeaderSendWelcomeEmail": "Send Welcome Email",
    "BroadworksProvisioningAddEntry": "Add entry...",
    "BroadworksProvisioningItemExtension": "Extension",
    "BroadworksProvisioningItemHospitality": "Hospitality",
    "BroadworksProvisioningItemAcdAgent": "ACD Agent",
    "BroadworksProvisioningItemEssentials": "Essentials",
    "BroadworksProvisioningItemProfessional": "Professional",
    "BroadworksProvisioningItemCallCentreAgent": "Call Centre Agent",
    "BroadworksProvisioningItemEnterprise": "Enterprise",
    "BroadworksProvisioningItemCallCentreSupervisor": "Call Centre Supervisor",
    "BroadworksProvisioningItem1000": "Akixi 1000",
    "BroadworksProvisioningItem2000": "Akixi 2000",
    "BroadworksProvisioningButtonDiscardChanges": "Discard Changes",
    "BroadworksProvisioningButtonSave": "Save",
    "BroadworksProvisioningButtonActions": "Actions",
    "BroadworksProvisioningButtonDelete": "Delete",
    "BroadworksProvisioningButtonEdit": "Edit",
    "BroadworksProvisioningValueIsRequired": "Value is required.",
    "NAME": "Provisioning"
}